<template>
    <textarea v-model="val" :disabled="disabled" class="form-control "></textarea>
</template>
<script>
export default {
    props: ['antecedente','value','disabled'],
    data () {
        return{
            val:this.value,
        }
    },
    watch:{
        val:function(){
            this.$emit('input',this.val);
        },
        
    }
}
</script>


